<template>
  <v-dialog
    v-model="isVisible"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        class="mx-0"
        :disabled="disabled"
        x-small
        v-bind="attrs"
        v-on="on"
      >
        Add Stop
        <!-- <v-icon>mdi-map-marker-plus</v-icon> -->
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h3">{{ $t("add_location") }}</span>
      </v-card-title>

      <v-card-text>
        <v-row class="mb-3">
          <v-col cols="12">
            <v-text-field
              v-model="address"
              dense
              label="Address *"
            />
          </v-col>
          <v-col md="6">
            <v-text-field
              v-model="coordinates.lat"
              dense
              :label="$t('latitude_*')"
              @change="updateMarkerPosition"
            />
          </v-col>
          <v-col md="6">
            <v-text-field
              v-model="coordinates.lng"
              dense
              :label="$t('longitude_*')"
              @change="updateMarkerPosition"
            />
          </v-col>
        </v-row>
        <gmap-map
          ref="mymap"
          :zoom="14"
          :center="position"
          style="width: 100%; height: 350px"
        >
          <gmap-marker
            :position="position"
            :draggable="true"
            @drag="updateCoordinates"
          />
          <!-- @click="center = position" -->
        </gmap-map>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="closeForm()"
        >
          Close
        </v-btn>
        <v-btn
          color="primary"
          text
          :disabled="!(address && coordinates)"
          @click="saveLocation"
        >
          {{ $t("save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
export default {
  // components: {
  //   LMap,
  //   LTileLayer,
  //   LMarker,
  // },
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    tenantId: {
      type: Number,
      default() {
        return 0;
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      isVisible: false,

      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?lang=en",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 14,
      center: [24.87847, 67.0645625],
      markerLatLng: [24.87847, 67.0645625],
      //
      position: {
        lat: 24.87847,
        lng: 67.0645625,
      },
      //

      address: "",
      coordinates: {
        lat: 24.87847,
        lng: 67.0645625,
      },
    };
  },
  computed: {},
  async mounted() {},
  methods: {
    updateCoordinates(location) {
      this.coordinates = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },
    updateMarkerPosition() {
      const lat = parseFloat(this.coordinates.lat);
      const lng = parseFloat(this.coordinates.lng);
      // Update marker position
      this.$refs.mymap.$mapObject.panTo({ lat, lng });
      this.$refs.mymap.$mapObject.setCenter({ lat, lng });

      // Update coordinates data
      this.position = { lat, lng };
      this.coordinates = { lat, lng };
    },
    closeForm() {
      this.address = null;
      this.coordinates = {
        lat: 24.87847,
        lng: 67.0645625,
      };
      this.isVisible = false;
    },
    async saveLocation() {
      if (this.address && this.coordinates) {
        const params = {
          tenant_id: this.tenantId,
          location: this.address,
          lat: this.coordinates.lat,
          long: this.coordinates.lng,
        };
        await this.$store
          .dispatch("truckistanRoute/addLocation", params)
          .then(() => {
            this.$store.dispatch("truckistanRoute/getLocations", {
              tenant_id: this.tenantId,
            });

            this.closeForm();
          })
          .catch((error) => {
            this.$store.dispatch("alerts/error", error.response?.data?.message);
          });
      }
    },
  },
};
</script>
<style lang="sass" scoped>
.col
  padding: 0 1rem !important
</style>
